import { h, Component } from 'preact'
import PropTypes from 'prop-types'
import Header from './layout/Header'
import Footer from './layout/Footer'
import { Spinner } from './visual'

/* global window */

class Page extends Component {
  constructor() {
    super()
    this.updateDimensions = this.updateDimensions.bind(this)
    this.state = { width: 1900, height: 800, loading: true }
  }
  getChildContext() {
    return { hostname: this.props.hostname, windowDimensions: this.state }
  }
  componentDidMount() {
    if (typeof window !== 'undefined') {
      this.updateDimensions()
      window.addEventListener('resize', this.updateDimensions)
    }
  }
  componentWillUnmount() {
    if (typeof window !== 'undefined') {
      window.removeEventListener('resize', this.updateDimensions)
    }
  }
  updateDimensions() {
    this.setState({ width: window.innerWidth, height: window.innerHeight })
  }
  render() {
    if (typeof window !== 'undefined' && this.state.loading) {
      if (window.requestAnimationFrame) {
        window.requestAnimationFrame(() => {
          this.setState({ loading: false })
        })
      } else {
        setTimeout(() => {
          this.setState({ loading: false })
        }, 0)
      }
    }
    return this.state.loading ? (
      <div className="content">
        <div
          style={{
            minHeight: 500,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          <Spinner />
        </div>
      </div>
    ) : (
      <div>
        {this.props.children}
        <Footer gaSubscribeId={this.props.gaFooterSubscribeId} />
      </div>
    )
  }
}

Page.childContextTypes = {
  hostname: PropTypes.string,
  windowDimensions: PropTypes.object,
}

export default Page



// WEBPACK FOOTER //
// ./components/Page.js